export const LOAD_STATS_TABLE_REQUEST = 'LOAD_STATS_TABLE_REQUEST';
export const LOAD_STATS_TABLE_SUCCESS = 'LOAD_STATS_TABLE_SUCCESS';
export const LOAD_STATS_TABLE_FAILURE = 'LOAD_STATS_TABLE_FAILURE';

export const LOAD_STATS_TABLE_MORE_REQUEST = 'LOAD_STATS_TABLE_MORE_REQUEST';
export const LOAD_STATS_TABLE_MORE_SUCCESS = 'LOAD_STATS_TABLE_MORE_SUCCESS';

export const LOAD_STATS_TABLE_EXPORT_REQUEST = 'LOAD_STATS_TABLE_EXPORT_REQUEST';
export const LOAD_STATS_TABLE_EXPORT_SUCCESS = 'LOAD_STATS_TABLE_EXPORT_SUCCESS';